import React from 'react';
import * as UIcons from '@iconscout/react-unicons';
import Btn, { FormBtn } from './Btn';
import { withTranslation } from 'react-i18next';

export default withTranslation()(function HeaderComponent({ t, title, btnText, btnClick, showSearch, hideBtn, btn, formBtn, cancelBtn }) {
  return (
    <div className="flex items-center w-full">
      <h1 className="text-md md:text-xl font-bold grow text-secondary">{title}</h1>

      <div className="flex items-center mb-5 md:mb-0">
        {
          showSearch && (
            <form className="relative mr-4">
              <input type="text" name="search" className="bg-grey p-3 rounded-lg pl-12" placeholder="Search" />
              <UIcons.UilSearch className="text-placeholder absolute top-3 left-2 text-sm" />
            </form>
          )
        }

        {
          formBtn ? (
            <>
              <FormBtn
                content={btnText ?? t('misc.save')}
                className="h-10 md:h-12 bg-primary text-white rounded-lg"
              />
            </>
          ) : (
            <>
              {
                cancelBtn && (
                  <Btn
                    content={cancelBtn?.text ?? t('misc.save')}
                    className="h-10 md:h-12 border border-primary text-primary hover:text-white rounded-lg mr-2"
                    click={cancelBtn?.click}
                  />
                )
              }
              {
                !hideBtn && (
                  <Btn
                    content={btnText ?? t('misc.save')} disabled={btn?.disabled}
                    className="h-10 md:h-12 bg-primary text-white rounded-lg"
                    click={btnClick}
                  />
                )
              }

            </>
          )
        }
      </div>
    </div>
  )
})
